import React, { useState } from "react";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

// import JS files

// import others files
import bullletIcon from "../../assets/imgs/red-bullet.svg";
import MuiButton from "../shares/mui/MuiButton";
import MuiDrawer from "../shares/mui/MuiDrawer";
import Filter from "./Filter";
import MuiSelect from "../shares/mui/MuiSelect";
import { useForm } from "react-hook-form";
import MuiDatePicker from "../shares/mui/MuiDatePicker";

const newsMediaTypeList = [
  {
    value: "video",
    name: "ویدیو",
  },
  {
    value: "image",
    name: "گزارش تصویری",
  },
  {
    value: "audio",
    name: "رادیو",
  },
];

const newsTypeList = [
  {
    value: "all",
    name: "همه اخبار",
  },
  {
    value: "company",
    name: "اخبار شرکت‌ها",
  },
  {
    value: "most_view",
    name: "پربیننده‌ترین",
  },
];
const MobileFilter = (props) => {
  const {
    register,
    handleSubmit,
    watch,
    setError,
    control,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    defaultValues: {},
  });

  const [openDrawer, setOpenDrawer] = useState(false);

  const toggleDrawer = () => {
    setOpenDrawer((before) => !before);
  };

  return (
    <>
      <div className="flex justify-between items-center">
        <div className="flex justify-between items-center">
          <img src={bullletIcon} className="self-start mt-[0.4rem] ml-2" />
          <span className="text-myblacks-400 font-bold ">{props.header}</span>
        </div>
        <MuiButton
          onClick={toggleDrawer}
          variant="contained"
          color="primary"
          text="فیلتر"
          size="small"
          icon={<FilterAltIcon />}
        />
      </div>
      <MuiDrawer
        anchor="left"
        openDrawer={openDrawer}
        setOpenDrawer={setOpenDrawer}
      >
        <div className={`w-screen h-full relative`}>
          <div className="grid grid-cols-3 items-center p-4 shadow-md mb-8">
            <div
              className="text-xs text-myblacks-200 flex items-center"
              onClick={toggleDrawer}
            >
              <ArrowForwardIosIcon sx={{ fontSize: "1rem" }} />
              <span>بازگشت</span>
            </div>
            <span className=" text-center text-myblacks-300 font-bold">
              فیلتر
            </span>
          </div>
          <div className="py-4 px-8">
            <MuiSelect
              size="small"
              onChange={(e) => props.setNewsType(e.target.value)}
              inputLabel="نوع خبر"
              label="news_type_label"
              control={control}
              name="news_type_name"
              value={props.newsType}
              defaultValue={props.newsType}
              register={{
                required: {
                  value: true,
                  message: "نقش کاربردی را انتخاب کنید",
                },
              }}
              labelId="sent_typel-label"
              id="sent_type-select"
              menuItems={
                props.type == "media" ? newsMediaTypeList : newsTypeList
              }
              fromApi={false}
              keyOnLoop="name"
            />
            <div className="mt-8">
              <MuiDatePicker
                onChange={(date) => props.setNewsDate(date)}
                value={props.newsDate}
                name="date_name"
                label="تاریخ"
              />
            </div>
            <div className="px-8 w-full absolute bottom-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <MuiButton
                variant="contained"
                color="primary"
                text="اعمال فیلتر"
                type="submit"
                isFullWidth
                onClick={()=>{
                  props.filter_api();
                  toggleDrawer();
                }}
              />
            </div>
          </div>
        </div>
      </MuiDrawer>
    </>
  );
};

export default MobileFilter;
